import React, { Component } from 'react'
import './index.less'

import CountDown2 from '../Countdown2'
import score from 'src/helper/score'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'
import { isVoca } from 'src/helper/tool'

export default class extends Component {
  render() {
    let { language, lang, remainTime } = this.props
    let thisRoomRank = this.props.thisRoomRank || []
    let thisRoomMyRank = this.props.thisRoomMyRank || {}
    let isRankRange = (index) => {
      if (thisRoomMyRank.rank == index + 4) {
        return 'active'
      } else {
        return ''
      }
    }
    return (
      <div>
        {/* this-week-top */}
        <div className="room-this-week">
          <div className="title">{lang.thisweek}</div>

          <CountDown2 lang={lang} language={language} remaintime={remainTime} />

          <div className="this-week-rank">
            <div
              className="rank-2"
              onClick={jumpToRoom.bind(this, thisRoomRank && thisRoomRank.length > 1 && thisRoomRank[1].gid)}
            >
              <img src="/img/activity/pk/r22.png" alt="" />
            </div>
            <div
              className="rank-1"
              onClick={jumpToRoom.bind(this, thisRoomRank && thisRoomRank.length > 0 && thisRoomRank[0].gid)}
            >
              <img src="/img/activity/pk/r11.png" alt="" />
            </div>
            <div
              className="rank-3"
              onClick={jumpToRoom.bind(this, thisRoomRank && thisRoomRank.length > 2 && thisRoomRank[2].gid)}
            >
              <img src="/img/activity/pk/r33.png" alt="" />
            </div>
          </div>
          <div className="rank2">
            <img src={(thisRoomRank && thisRoomRank.length > 1 && thisRoomRank[1].logourl) || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
          </div>
          <div className="rank1">
            <img src={(thisRoomRank && thisRoomRank.length > 0 && thisRoomRank[0].logourl) || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
          </div>
          <div className="rank3">
            <img src={(thisRoomRank && thisRoomRank.length > 2 && thisRoomRank[2].logourl) || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
          </div>
          <div className="rank2-info">
            <div className="name">{(thisRoomRank && thisRoomRank.length > 1 && thisRoomRank[1].name) || ''}</div>
            <div className="id">ID:{(thisRoomRank && thisRoomRank.length > 1 && thisRoomRank[1].dgid) || ''}</div>
            <div className="money">
              <span>{score(thisRoomRank && thisRoomRank.length > 1 && thisRoomRank[1].val)}</span>
              <img src="/img/activity/pk/bs.png" alt="" />
            </div>
          </div>
          <div className="rank1-info">
            <div className="name">{(thisRoomRank && thisRoomRank.length > 0 && thisRoomRank[0].name) || ''}</div>
            <div className="id">ID:{(thisRoomRank && thisRoomRank.length > 0 && thisRoomRank[0].dgid) || ''}</div>
            <div className="money">
              <span>{score(thisRoomRank && thisRoomRank.length > 0 && thisRoomRank[0].val)}</span>
              <img src="/img/activity/pk/bs.png" alt="" />
            </div>
          </div>
          <div className="rank3-info">
            <div className="name">{(thisRoomRank && thisRoomRank.length > 2 && thisRoomRank[2].name) || ''}</div>
            <div className="id">ID:{(thisRoomRank && thisRoomRank.length > 2 && thisRoomRank[2].dgid) || ''}</div>
            <div className="money">
              <span>{score(thisRoomRank && thisRoomRank.length > 2 && thisRoomRank[2].val)}</span>
              <img src="/img/activity/pk/bs.png" alt="" />
            </div>
          </div>
        </div>
        {/* this-week-top */}

        {/* this-week-bottom */}
        <div className="room-select-list">
          {thisRoomRank &&
            thisRoomRank.length > 0 &&
            thisRoomRank
              .filter((ele, index) => {
                return index > 2
              })
              .map((item, index) => {
                if (index <= 6) {
                  return (
                    <div className={`list ${isRankRange(index)} ${language == 'ar' && 'arlang'}`} key={index}>
                      <div className="id">{index + 4}</div>
                      <div
                        className="ava"
                        onClick={jumpToRoom.bind(
                          this,
                          thisRoomRank && thisRoomRank[index + 3] && thisRoomRank[index + 3].gid
                        )}
                      >
                        <img src={item.logourl} alt="" />
                      </div>
                      <div className="info">
                        <div className="name">{item.name}</div>
                        <div className="info-id">
                          ID:
                          {item.dgid}
                        </div>
                      </div>
                      <div className="money">
                        <span>{score(item.val)}</span>
                        <img src="/img/activity/pk/bs.png" alt="" />
                      </div>
                    </div>
                  )
                }
              })}
          <div className="list" style={{ display: `${thisRoomRank.length < 4 ? 'flex' : 'none'}` }}></div>
          {/* 我的 */}
          <div
            style={{ display: `${thisRoomMyRank.rank == '10+' ? 'flex' : 'none'}` }}
            className={`list myActive ${thisRoomMyRank.rank == '10+' ? 'active' : ''} ${language == 'ar' && 'arlang'}`}
          >
            <div className="id">{thisRoomMyRank.rank}</div>
            <div className="ava" onClick={jumpToRoom.bind(this, thisRoomMyRank && thisRoomMyRank.gid)}>
              <img src={thisRoomMyRank.logourl || (isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/de_img_logo.png')} alt="" />
            </div>
            <div className="info">
              <div className="name">{thisRoomMyRank.name}</div>
              <div className="info-id">ID:{thisRoomMyRank.dgid}</div>
            </div>
            <div className="money">
              <span>{score(thisRoomMyRank.val)}</span>
              <img src="/img/activity/pk/bs.png" alt="" />
            </div>
          </div>
        </div>
        <div className="last-select"></div>
        {/* this-week-bottom */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/pkactivity/RoomThisWeek/index.js